import { Form, Input } from 'antd';
import { CompWithFormProp } from '../../constants/constants';

export const Tasks = ({ form }: CompWithFormProp) => {
  const selectedGrade = Form.useWatch(
    ['registration', 'selectedSubject'],
    form,
  );

  return (
    <Form.Item
      label="Uždaviniai"
      name={['registration', 'tasks']}
      style={{ display: selectedGrade ? 'block' : 'none' }}
    >
      <Input.TextArea rows={2} />
    </Form.Item>
  );
};
